import { Checkbox } from "@nokia-csf-uxr/ccfk";
import { createSlice } from "@reduxjs/toolkit";
import { error } from "console";
import { set } from "lodash";
import { Provider } from "react-redux";
import { setProp } from "Store/Actions";
import z from "zod";



type NetworkComment = {
  cid: string;
  network_id: string;
  comment: string;
  uid: string;
  created_at: string;
  updated_at: string;
};

interface NetworkCommentsState {
  comments: NetworkComment[];
  loading: boolean;
  error: string | null;
}



interface NetworkState {
  // other existing fields ...
  networkList: any[];
  networkListLoading: boolean;
  networkListError: boolean;
  totalNetworksCount: number;
  networkMarketFollowup: any;
  networkEditContentLoading: boolean,
  limitPerPageForSliceContact: number,
  offsetForSliceContact: number,
  networkComments: NetworkCommentsState;
  currentActiveTab: number;
  networkDetailsBreadCrumTitle: string;
  commentData: any;
  columnFilter: any;
  selectedNetworkDialogData: any;
  selectedMapFollowDetails: any;
  generateNetworkId: boolean;
  validOfferId: boolean;
  newNeworkIdStatus: boolean;
  networkOfferLoading: boolean;
  allAccountsForExternalSelltoParty: any;
  selectedItemsSelltoParty: any;
  selectedItemsEndCustomer: any;
  allAccountsForExternalEndCustomer: any;
  showCommentsSectionProps: any
  serviceDaysProps: any;
  sliceIds: any;
  sliceIdsGR: any;
  sliceIDsSpare: any
  allSliceIds: any;
  defaultSliceIds: any,
  showNtkCustomizeModal: boolean,
  apiColumns: any,
  ucpId: any,
  pageOrComponent: any,
  columnNames: string[],
  page_or_component: any,
  columnDefs: any,
  initiateHandoverShow: boolean,
  initiateHandoverStatus: boolean,
  initiateHandoverSliceIds: any,
  exportCheck: any,
  initiateCPMStatus: boolean,
  dcConfigData: any,
  showLifeCycleSectionProps: any,
  previousLifecycleValue: string,
  previousScrmidValue: string,
  previousTsrsTicketValue: string,
  scrmiTicketCheck: any,
  lifeCycleHistory: any,
  lifeCycleHistoryLoading: boolean
  networkDCAccountInfo: any,
  d2cLink: boolean,
  d2cStatusLoading: boolean,
  d2cFormLink: string,
  networkDcOverried: boolean,
  dcAccessadminEmailFirst: string,
  dcAccessadminEmailSecond: string,
  confirmSaveDialog: boolean,
  disconnectReason: string,
  disconnectReasonComment: string,
  unsetSliceIds: any,
  unsetSliceIdsGR: any,
  unsetSliceIDsSpare: any
  networkContactContentLoading: boolean;
  showBulkUploadModal: boolean;
}

const initialData: NetworkState = {
  networkList: [],
  networkListLoading: false,
  networkListError: false,
  totalNetworksCount: 0,
  currentActiveTab: 1,
  networkDetailsBreadCrumTitle: "Network details",
  networkMarketFollowup: {
    networkInformation: {
      lifecycle: "",
      tsrs_ticket_id: "",
      old_scrm_id: "",
      new_scrm_id: "",
      next_renewal_offer_date: "",
      sites: "",
      active_use_case: "",
      non_nokia_ue: "",
      non_nokia_app: "",
      segment: "",
      nokia_app: "",
      nokia_ue: "",
      no_auto_renewal_comments: "",
      preferred_communication_channel: "",
      auto_renewal: 0,
      multinetwork_renewal: false,
      scrm_type: "",
      scrm_instructions: "",
      disconnect_reason: "",
      disconnect_reason_comment: "",
      scrm_validated: false,
      renewal_term: "",
      invoice_frequency: "",
      hardware_refresh: false
    },
    metaData: {
      renewalTerm: "",
      invoicing_frequency: "",
      network_details: "",
      renewal_duration: ""
    },
    contactInfo: [],
    updatedcontactInfo: [],
    contactInfoOld: [],
    orders: {
      existing_offer_id: [],
      new_offer_id: [],
    },
  },
  defaultSliceIds: [],
  allSliceIds: [],
  sliceIds: [],
  sliceIdsGR: [],
  sliceIDsSpare: [],
  networkEditContentLoading: false,
  networkContactContentLoading: false,
  showBulkUploadModal: false,
  limitPerPageForSliceContact: 50,
  offsetForSliceContact: 0,
  allAccountsForExternalSelltoParty: [],
  allAccountsForExternalEndCustomer: [],
  selectedItemsSelltoParty: [],
  selectedItemsEndCustomer: [],
  networkComments: {
    comments: [],
    loading: false,
    error: null
  },
  commentData: {
    isEdit: false,
    selectedComment: {}
  },
  columnFilter: {
    network_id: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    slice: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    slice_spare: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    slice_gr: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    core_offer_id: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    technical_status: {
      filter: [],
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    sw_sla: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    lifecycle: {
      filter: [],
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    network_sales_owners: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    account_name: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    end_customer_account_name: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    network_classification: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    network_location: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    network_metadata_market: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    created: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "like",
      filterCheck: false
    },
    createdStartDate: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "between",
      filterCheck: false
    },
    next_renewal_start_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "between",
      filterCheck: false
    },
    next_renewal_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "like",
      filterCheck: false
    },
    network_start_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "between",
      filterCheck: false
    },
    next_renewal_offer_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "like",
      filterCheck: false
    },
    next_renewal_offer_start_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "between",
      filterCheck: false
    },
    disconnect_reason: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    disconnect_reason_comment: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    },
    network_end_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "like",
      filterCheck: false
    },
    inside_sales_owners: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "",
      filterCheck: false
    },
    network_last_online: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "like",
      filterCheck: false
    },
    network_last_online_start_date: {
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      datestatus: "between",
      filterCheck: false
    },
    associated_offers:{
      filter: "",
      sort: "",
      checkempty: false,
      checkNonEmpty: false,
      filterCheck: false
    }
  },
  selectedNetworkDialogData: {
    showNetworkMasterDialog: false,
    selectedNetworkData: {},
    dialogMode: "add"
  },
  selectedMapFollowDetails: {},
  generateNetworkId: false,
  validOfferId: false,
  newNeworkIdStatus: true,
  networkOfferLoading: false,
  showCommentsSectionProps: {
    showCommentsSection: false,
    showCommentsWrapperDiv: true,
    commentsOverlayPanelWidth: 0
  },
  showLifeCycleSectionProps: {
    showLifyCycleSection: false,
    showLifeCycleWrapperDiv: true,
    lifeCycleOverlayPanelWidth: 0
  },
  serviceDaysProps: {
    serviceDaysList: [],
    serviceDaysLoading: false,
  },
  showNtkCustomizeModal: false,
  apiColumns: [],
  ucpId: "",
  pageOrComponent: "",
  columnNames: [],
  page_or_component: "",
  columnDefs: [],
  initiateHandoverShow: false,
  initiateHandoverStatus: false,
  initiateHandoverSliceIds: [],
  exportCheck: false,
  initiateCPMStatus: true,
  dcConfigData: {
    configFiles: [],
    downloadHistory: [],
    selectedFile: null,
    showPreviewOverlay: false,
    showGenerateDialog: false,
    activeTab: 'config', // 'config' or 'download'
    loading: false,
    error: null,
    selectedConfigDetails: {},
    showGenerateDialogLoading: false,
    ProvisionedConfigFiles: [],
    provisionLog: {allSkippedItems:[], allAssociatedOffers:[]}
  },
  previousLifecycleValue: "",
  previousScrmidValue: "",
  previousTsrsTicketValue: "",
  scrmiTicketCheck: {status: true,message: "",type:"", scrmidStatus: true, zendeskTicketStatus: true},
  lifeCycleHistory: [],
  lifeCycleHistoryLoading: false,
  networkDCAccountInfo: {},
  d2cLink: false,
  d2cStatusLoading: true,
  d2cFormLink: "",
  networkDcOverried: false,
  dcAccessadminEmailFirst: "",
  dcAccessadminEmailSecond:"",
  confirmSaveDialog: false,
  disconnectReason: "",
  disconnectReasonComment: "",
  unsetSliceIds: [],
  unsetSliceIdsGR: [],
  unsetSliceIDsSpare: []
}

const networkMasterSlice = createSlice({
  name: 'networkMaster',
  initialState: initialData,
  reducers: {
    setNetworkMasterList(state, action) {
      const data = action.payload
      state.networkList = data
    },
    setNetworkMasterListProps(state, action) {
      const { key, value } = action.payload
      state[key] = value
    },
    setNetworkMarketFollowupField(state, action) {
      const { section, key, value, override } = action.payload;
      // if (state.networkMarketFollowup && state.networkMarketFollowup[section]) {
      //   state.networkMarketFollowup[section][key] = value;
      // }
      if (section === 'contactInfo') {
        const contactIndex = state.networkMarketFollowup.contactInfo.findIndex(item => item.contact_type === key);
        if (contactIndex !== -1) {
          state.networkMarketFollowup.contactInfo[contactIndex].contact_email = value;
          state.networkMarketFollowup.contactInfo[contactIndex].override = override;
        } else {
          state.networkMarketFollowup.contactInfo.push({ contact_type: key, contact_email: value, override: override });
        }
      } else {
        state.networkMarketFollowup[section][key] = value;
      }

    },
    setNetworkMarketFollowupFieldOld(state, action) {
      const { section, key, value, override } = action.payload;
      // if (state.networkMarketFollowup && state.networkMarketFollowup[section]) {
      //   state.networkMarketFollowup[section][key] = value;
      // }
      if (section === 'contactInfoOld') {
        const contactIndex = state.networkMarketFollowup.contactInfoOld.findIndex(item => item.contact_type === key);
        if (contactIndex !== -1) {
          state.networkMarketFollowup.contactInfoOld[contactIndex].contact_email = value;
          state.networkMarketFollowup.contactInfoOld[contactIndex].override = override;
        } else {
          state.networkMarketFollowup.contactInfoOld.push({ contact_type: key, contact_email: value, override: override });
        }
      } else {
        state.networkMarketFollowup[section][key] = value;
      }

    },
    addOrUpdateContactInfoField(state, action) {
      const { contact_type, contact_email } = action.payload;
      // Normalize for comparison (e.g., trim, lowercase if needed)
      const email = contact_email


      const { contactInfo, updatedcontactInfo, contactInfoOld } = state.networkMarketFollowup;

      const oldIndex = contactInfoOld.findIndex(c => c.contact_type === contact_type);
      const originalEmail = oldIndex > -1 ? contactInfoOld[oldIndex].contact_email?.trim() : null;

      const infoIndex = contactInfo.findIndex(c => c.contact_type === contact_type);
      if (infoIndex > -1) {
        contactInfo[infoIndex].contact_email = email;
      } else if (email) {
        contactInfo.push({ contact_type, contact_email: email });
      }

      const updatedIndex = updatedcontactInfo.findIndex(c => c.contact_type === contact_type);
      if (originalEmail !== email) {
        if (updatedIndex > -1) {
          updatedcontactInfo[updatedIndex].contact_email = email;
        } else {
          updatedcontactInfo.push({ contact_type, contact_email: email });
        }
      } else if (updatedIndex > -1) {
        updatedcontactInfo.splice(updatedIndex, 1);
      }

    },
    removeContactInfoField(state, action) {
      const { contact_type } = action.payload;
      state.networkMarketFollowup.contactInfo = state.networkMarketFollowup.contactInfo.filter(c => c.contact_type !== contact_type);
      state.networkMarketFollowup.updatedcontactInfo = state.networkMarketFollowup.updatedcontactInfo.filter(c => c.contact_type !== contact_type);
    },
    setContactInfoOverride(state, action) {
      const { contact_type, override } = action.payload;
      const contactIndex = state.networkMarketFollowup.contactInfo.findIndex(item => item.contact_type === contact_type);
      if (contactIndex !== -1) {
        state.networkMarketFollowup.contactInfo[contactIndex].override = override;
      } else {
        state.networkMarketFollowup.contactInfo.push({ contact_type, contact_email: "", override });
      }
    },
    resetNetworkData(state) {
      state.networkMarketFollowup = initialData.networkMarketFollowup;
      state.commentData = initialData.commentData;
      state.currentActiveTab = initialData.currentActiveTab;
      state.showCommentsSectionProps = initialData.showCommentsSectionProps;
      state.showLifeCycleSectionProps = initialData.showLifeCycleSectionProps;
      state.dcConfigData = initialData.dcConfigData;
      state.networkDCAccountInfo = initialData.networkDCAccountInfo;
    },
    setNetworkComments(state, action) {
      state.networkComments['comments'] = action.payload;
    },
    setNetworkCommentsProps(state, action) {
      const { key, value } = action.payload
      state.networkComments = {
        ...state.networkComments,
        [key]: value,
      };
    },
    setCommentData(state, action) {
      const { isEdit, selectedComment } = action.payload;
      state.commentData.isEdit = isEdit;
      state.commentData.selectedComment = selectedComment;
    },
    setColumnFilter: (state, action) => {
      const { columnId, type, value } = action.payload;
      if (!state.columnFilter[columnId]) {
        state.columnFilter[columnId] = {};
      }
      state.columnFilter[columnId][type] = value
    },
    setSelectedNetworkDialogData(state, action) {
      const { showNetworkMasterDialog, selectedNetworkData, dialogMode } = action.payload;
      state.selectedNetworkDialogData.showNetworkMasterDialog = showNetworkMasterDialog;
      state.selectedNetworkDialogData.selectedNetworkData = selectedNetworkData;
      state.selectedNetworkDialogData.dialogMode = dialogMode;
    },
    setServiceDaysProps(state, action) {
      const { key, value } = action.payload;
      state.serviceDaysProps = {
        ...state.serviceDaysProps,
        [key]: value,
      };
    },
    setDCConfigData(state, action) {
      const { key, value } = action.payload;
      state.dcConfigData[key] = value;
    },
    setDCConfigSelectedFile(state, action) {
      state.dcConfigData.selectedFile = action.payload;
    },
    setDCConfigPreviewOverlay(state, action) {
      state.dcConfigData.showPreviewOverlay = action.payload;
    },
    setDCConfigActiveTab(state, action) {
      state.dcConfigData.activeTab = action.payload;
    },
    setNetworkDCAccountInfo(state, action) {
      state.networkDCAccountInfo = action.payload;
    }
  },
  extraReducers(builder) {
    builder.addCase(setProp, (state, action: {
      payload: any;
      type: string;
      slice: string;
    }) => {
      if (action.payload.slice === networkMasterSlice.name) {
        state[action.payload.key] = action.payload.value;
      }
    });
  }
})

export default networkMasterSlice.reducer;
//export const { setNetworkMasterList, setNetworkMasterListProps, setNetworkMarketFollowupField, setCommentData, setNetworkCommentsProps,resetNetworkData, setNetworkMarketFollowupFieldOld, addOrUpdateContactInfoField, removeContactInfoField, setNetworkComments,setColumnFilter,setSelectedNetworkDialogData, setServiceDaysProps } = networkMasterSlice.actions;
export const { setNetworkMasterList, setNetworkMasterListProps, setNetworkMarketFollowupField, setCommentData, 
  setNetworkCommentsProps, 
  resetNetworkData, 
  setNetworkMarketFollowupFieldOld, 
  addOrUpdateContactInfoField, 
  removeContactInfoField, 
  setContactInfoOverride,
  setNetworkComments, 
  setColumnFilter, 
  setSelectedNetworkDialogData, 
  setServiceDaysProps,
  setDCConfigData,
  setDCConfigSelectedFile,
  setDCConfigPreviewOverlay,
  setDCConfigActiveTab,
  setNetworkDCAccountInfo
 } = networkMasterSlice.actions;

